import { useState, useEffect } from 'react';
import useSearchQueryParams from '@/hooks/useSearchQueryParams';
import { format } from 'date-fns';

export function usePropertyCard() {
  const { date } = useSearchQueryParams();
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const shouldShowHoverEffects = !isMobile && isHovered;

  const handleMouseEnter = () => !isMobile && setIsHovered(true);
  const handleMouseLeave = () => !isMobile && setIsHovered(false);

  const getPropertyLink = (propertyId: string) => {
    const fromDate = date?.from ? format(date?.from, 'yyyy-MM-dd') : '';
    const toDate = date?.to ? format(date?.to, 'yyyy-MM-dd') : '';
    if (fromDate && toDate) {
      return `/properties/${propertyId}?from=${fromDate}&to=${toDate}`;
    }
    return `/properties/${propertyId}`;
  };

  return {
    isMobile,
    isHovered,
    shouldShowHoverEffects,
    handleMouseEnter,
    handleMouseLeave,
    getPropertyLink,
  };
}
